(function($) {
	
	'use strict';
	var formValidator;
	var customSelect;

	var updateSubscriptionDetails = function(e, sel) {
		var select = (sel !== undefined) ? sel : $(this);
		var form = select.closest('form');
		var packageInputs = select.closest('.fieldset');

		formValidator.validateForm(packageInputs);

		if (!packageInputs.hasClass('has-error')) {
			updateSubscriptionRecap(form);
		}
	};

	var updateSubscriptionRecap = function(form) {
		var productId = form.find('.form-select[name=productId]').val();
		var quantity = form.find('.form-select[name=quantity]').val();
		var personId = form.find('input[name=personId]').val();
		var payerId = form.find('.form-select[name=useCardPersonId]').val();
		var payerId2 = form.find('.form-select[name=storeCardPersonId]').val();
		var url = '/action/shopUpdateSubscription';

		url += '?productId=' + productId;
		url += '&quantity=' + quantity;
		if (personId !== undefined) {
			url += '&personId=' + personId;
			if(payerId !== undefined && payerId !== '' && payerId !== 'new-card'){
				url += '&useCardPersonId=' + payerId;
			}
			if(payerId === 'new-card'){
				url += '&useCardPersonId=' + payerId2;
			}
		}
		url += '&summary=true';
		url += '&ajax=true';

		if (productId != '') {
			ajax(url, function (response) {
				var json = JSON.parse(response);
				$('.total-to-pay.amount', form).html(json.toPay);
				$('.pay-now.amount', form).html(json.toPayNow);
				if (json.promo !== '0.00' && json.promo !== '0,00') {
					$('.rebate-promo.amount', form).html(json.promo);
					$('.rebate-promo-ctn', form).slideDown();
				} else {
					$('.rebate-promo-ctn', form).slideUp();
				}
				if (json.rebatePerc !== '0.00' && json.rebatePerc !== '0,00') {
					$('.rebate-perc.amount', form).html(json.rebatePerc);
					$('.rebate-perc-ctn', form).slideDown();
				} else {
					$('.rebate-perc-ctn', form).slideUp();
				}
				if (json.rebateAmt !== '0.00' && json.rebateAmt !== '0,00') {
                    $('.rebate-amt.amount', form).html(json.rebateAmt);
                    $('.rebate-amt-ctn', form).slideDown();
                } else {
                    $('.rebate-amt-ctn', form).slideUp();
                }
                if (json.tax1 !== '0.00' && json.tax1 !== '0,00') {
                    $('.rebate-amt-tax1.amount', form).html(json.tax1);
                    $('.rebate-amt-tax1.codename', form).html(json.taxName1 + " (" + json.taxNbr1 + "): ");
                    $('.rebate-amt-tax1-ctn', form).slideDown();
                } else {
                    $('.rebate-amt-tax1-ctn', form).slideUp();
                }
                if (json.tax2 !== '0.00' && json.tax2 !== '0,00') {
                    $('.rebate-amt-tax2.amount', form).html(json.tax2);
                    $('.rebate-amt-tax2.codename', form).html(json.taxName2 + " (" + json.taxNbr2 + "): ");
                    $('.rebate-amt-tax2-ctn', form).slideDown();
                } else {
                    $('.rebate-amt-tax2-ctn', form).slideUp();
                }
                if (parseFloat(json.alreadyPaid.replace(',', '.')) === 0) {
                    $('.already-paid', form).parent().hide();
                } else {
                    $('.already-paid', form).parent().show();
                }
				$('.already-paid.amount', form).html(json.alreadyPaid);
				$('.pay-later.amount', form).html(json.toPayLater);
				$('.form-input[name=code]', form).val(json.promoName);

				var zero = $('html').attr('lang') === 'en' ? '0.00' : '0,00';
				$('.next-payment-date', form).html(json.toPayLater === zero && json.toPayNow === zero ? '-' : json.payDate);

				$('.price-recap-ctn', form).slideDown();
			}, true);
		}
	};

	var toggleSaveCard = function() {
		var t = $(this);
		var form = t.closest('form');

		if (t.prop('checked')) {
			form.append('<input type="hidden" name="storeCard" value="true"/>');
		} else {
			form.find('input[name="storeCard"]').remove();
		}
	};

	var modifySubscription = function(e) {
		if (e) e.preventDefault();
		
		var form = $(this);
        
        if (form.hasClass('submitting')) {
            return false;
        }

		formValidator.validateForm(form);

		if (form.hasClass('has-error')) {
			formValidator.showErrorPopup();
			return false;
		}

		// If card info exists, remove unused elements
		if (form.find('input[name="useCard"]')[0]) {
            if (form.find('input[name="cardToken"]').val()) {
                form.find('input[name="useCard"]').remove();
            } else {
                form.find('.form-box[data-id="cc-box-form"]').remove();
            }
		}
		form.find('.get-stripe-token').addClass('disabled');
		form.find('.select-state-input-ctn:not(.selected)').remove();
        
        // Append the renew value in the form
        var autoRenew = form.find('.form-check-input[name="renewCheck"]').prop('checked');
        form.find('input[name="renew"]').val(autoRenew);
        
        form.addClass('submitting');
		form[0].submit();
	};

	var checkCardChoice = function() {
		var t = $(this);
		var ccCtn = t.closest('form').find('.form-box[data-id="cc-box-form"]');

		if (t.val() === 'new-card') {
			ccCtn.slideDown();
			ccCtn.find('input.derequired, select.derequired').removeClass('derequired').addClass('required');
		} else {
			ccCtn.slideUp();
			ccCtn.find('input.required, select.required').removeClass('required').addClass('derequired');
		}
		updateSubscriptionRecap(t.closest(".user-subscription-modif-form"));
	};

	var cancelModifications = function() {
		var t = $(this);
		var personId = t.attr('data-id');

		$.ajax({
			url: '/action/shopUpdateSubscription',
			cache: false,
			method: 'POST',
			data: {
				personId: personId,
				cancelEdit: true,
				ajax: true
			},
			success: function (response) {
				if (response.indexOf('success') !== -1) {
					formValidator.showSuccessPopup();
					t.closest('form').find('.cancel-subscription-modification-ctn').slideUp();
				}
			}
		});
	};
	
	var showDetails = function(e){
		var dataId = $(this).attr("data-id");
		var form = $(".modif-subscription-form-outer-ctn[data-id = " + dataId + "]");
		if($(".price-recap-ctn.hide", form).length !== 0){
			updateSubscriptionDetails(null, $(".user-subscription-modif-form", form));					
		}
	};

	var toggleSubscription = function() {
		var t = $(this);
		var val = t.data('value');

		$.ajax({
			url: '/action/shopPauseSubscription',
			cache: false,
			method: 'POST',
			data: {
				pause: val,
				ajax: true
			},
			success: function (response) {
				if (response.indexOf('success') !== -1) {
					window.location.reload();
				} else if (response.indexOf('fail') !== -1) {
					formValidator.showErrorPopupAnimation('error-pause-subscription-msg');
				}
			}
		});
	};
    
    var fetchErrorMessage = function() {
        var ctn = $('.subscription-management-error');
        if (ctn.length) {
            ajax('/action/getCurrPaymentError', function(resp) {
                if (resp.trim() !== '') {
                    ctn.find('.alert-content')
                        .append("<br/>")
                        .append(resp);
                }
            }, true);
            ajax('/action/getPaymentStoreCardError', function(resp) {
                if (resp.trim() !== '') {
                    ctn.find('.alert-content')
                        .append("<br/>")
                        .append(resp);
                }
            }, true);
        }
    };
	
	$(window).ready(function (e) {
		formValidator = Fw.component.models().form;
		customSelect = Fw.component.models().customSelect;

		$('.modify-subscription-add-cart').change(updateSubscriptionDetails);
		$('.user-subscription-modif-form').on('submit', modifySubscription);
		$('.form-check-input[name=storeCardCheck]').click(toggleSaveCard);
		$('.form-input[name=useCardPersonId]').change(checkCardChoice);
		$('.form-input[name=storeCardPersonId]').change(function(){
			updateSubscriptionRecap($(this).closest(".user-subscription-modif-form"));
		});
		$('.cancel-subscription-modification').click(cancelModifications);
		$('.modify-artist-subscription-table-btn').click(showDetails);
		$('.toggle-pause-subscription-btn').click(toggleSubscription);
		
		if($('.modify-artist-subscription-table-btn').length === 0 && $(".user-subscription-modif-form").length !== 0){
			updateSubscriptionDetails(null, $(".user-subscription-modif-form"));
		}
        
        fetchErrorMessage();
	});
	
	Fw.page.export('subscriptionUpdate', {
		updateSubscriptionRecap: updateSubscriptionRecap
	});
	
})(jQuery);
